// extracted by mini-css-extract-plugin
module.exports = {"open":"OffCanvas_open__1Ucy2","openNav":"OffCanvas_openNav__2EMBr","close":"OffCanvas_close__1uJ4E"};